import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';
import heart from 'public/static/images/favorites/heart.svg';

export default css`
  .similar-listing-card {
    color: ${colors.BLACK};
    text-decoration: none;
  }

  .similar-listing-card:focus {
    outline: none;
  }

  .primary-photo {
    position: relative;
    width: 272px;
    height: 164px;
    border-radius: 8px;
    background-repeat: none;
    background-size: cover;
    background-position: center center;
    margin-bottom: 16px;

  }

  .favorite-heart {
    z-index: 1;
    position: absolute;
    top: 14px;
    right: 14px;
    height: 28px;
    width: 30px;
    border: none;
    background-color: transparent;
    background-image: url(${heart});
    background-repeat: no-repeat;
  }

  .primary, .price {
    font-weight: 600;
    font-size: 18px;
  }

  @media (min-width: ${screen.smMin}) {
    .primary, .price {
      font-size: 20px;
    }
  }

  .secondary {
    color: ${colors.G3};
    font-size: 16px;
    line-height 27px;
  }

  @media (min-width: ${screen.smMin}) {
    .secondary {
      font-size: 18px;
      line-height: 2;
    }
  }
`;
